import { isEmpty } from 'lodash';

import { publicationYearFieldsMap } from '@app/components';
import { DateRange } from '@app/utils';

export const getPublicationYearCQL = (
  publicationYear: DateRange | undefined
) => {
  if (!publicationYear || isEmpty(publicationYear)) {
    return '';
  }

  const { minDate, maxDate } = publicationYear;

  const minDateOperator =
    minDate && `${publicationYearFieldsMap.publicationYearMin}${minDate}`;
  const maxDateOperator =
    maxDate && `${publicationYearFieldsMap.publicationYearMax}${maxDate}`;

  if (minDate && maxDate) {
    return `${minDateOperator} AND ${maxDateOperator}`;
  }

  return minDateOperator || maxDateOperator || '';
};
